import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.timeout = setTimeout(() => this.dismissAll(), 6000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss(event) {
    event.target.closest("[data-flash-target='item']").remove()
  }

  dismissAll() {
    this.itemTargets.forEach((el) => el.remove())
  }
}
